const unProtectedRoutes = ['/', '/kia', '/readEmails', '/set-new-password', '/set-password', '/parineetihonda', '/kotharihyundai'];

export {
  unProtectedRoutes
};
